module.exports = __webpack_public_path__ + "img/ht20.8f73ad46.png";